/** Pending structure-change dot requires Organisation members + Requests tab read. */
export const canTrackStructureChangeRequestsUnread = (userHasPermission) =>
  userHasPermission("admin.organisationMembers", "read") &&
  userHasPermission("admin.organisationMembers.requests", "read");

/** Pending internal-applications dot requires Organisation members + Internal applications tab read. */
export const canTrackInternalApplicationsUnread = (userHasPermission) =>
  userHasPermission("admin.organisationMembers", "read") &&
  userHasPermission("admin.organisationMembers.internalApplications", "read");
